import { render, staticRenderFns } from "./CACG1080.vue?vue&type=template&id=0aa02b66&scoped=true"
import script from "./CACG1080Controller.ts?vue&type=script&lang=ts&external"
export * from "./CACG1080Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CACG1080.vue?vue&type=style&index=0&id=0aa02b66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa02b66",
  null
  
)

export default component.exports